import { AnimatedImages } from './AnimatedImages';

export type FunnelImage = {
  src: string;
  alt: string;
  width?: number;
  height?: number;
};

export type FunnelVideo = {
  src: string;
  alt: string;
  autoplay?: boolean;
  muted?: boolean;
  controls?: boolean;
};

export type ScreenBackground = {
  desktopImage: FunnelImage;
  mobileImage: FunnelImage;
};

// TODO think about merge with top
export type ScreenBackgroundType = {
  backgroundDesktop: string;
  backgroundMobile: string;
};

export enum MediaVariant {
  IMAGE = 'IMAGE',
  ANIMATED_IMAGE = 'ANIMATED_IMAGE',
  VIDEO = 'VIDEO',
}

export interface ImageContent extends FunnelImage {
  variant: MediaVariant.IMAGE;
}

export interface AnimatedImageContent {
  animatedImage: AnimatedImages;
  variant: MediaVariant.ANIMATED_IMAGE;
}

export interface VideoContent extends FunnelVideo {
  variant: MediaVariant.VIDEO;
}

export type MediaData = ImageContent | AnimatedImageContent | VideoContent;
